import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import isEmpty from 'lodash.isempty'
import ListFromTable from 'components/common/ListFromTable'
import {
  sisenseFetchTableData,
  sisenseClearStateList,
  sisenseDelete,
} from 'reducers/sisense/reducer'
import * as ROUTE from 'constants/appRouting'
import ActionCollection from 'types/table/ActionCollection'
import Action from 'types/table/Action'
import UrlHelper from 'helpers/url'
import ColumnCollection from 'types/table/ColumnCollection'
import Column from 'types/table/Column'
import DateColumn from 'types/table/DateColumn'
import Sort from 'lib/psfs/Sort'
import ActiveColumn from 'types/table/ActiveColumn'
import messages from './translate'

class SisenseDashboardList extends ListFromTable {
  constructor(props) {
    super(props)
    this.getTableData = props.sisenseFetchTableData
    this.deleteEntity = props.sisenseDelete
    this.clearReducerState = props.sisenseClearStateList
    this.asyncData = true
    this.loadingData = true
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const { licenseeId, tableData } = this.props

    if (nextProps.licenseeId !== licenseeId) {
      this.reloadTableData(ROUTE.SISENSE_LIST)

      return false
    }

    if (tableData !== nextProps.tableData) {
      this.loadingData = false
    }

    return super.shouldComponentUpdate(nextProps, nextState, nextContext)
  }

  getTableProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.sisenseDashboardList),
      showFilterBar: true,
      sorting: true,
      paging: true,
      searching: true,
      creating: true,
    }
  }

  getCreateButton() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.createButton),
      link: ROUTE.SISENSE_CREATE,
    }
  }

  getColumns() {
    const {
      intl: { formatMessage },
    } = this.props
    const columns = new ColumnCollection()

    columns.add(new Column('id', 'ID', { sorting: true }))
    columns.add(
      new Column('name', formatMessage(messages.name), {
        sorting: true,
        defaultSort: true,
        defaultSortOrder: Sort.ASC,
      }),
    )
    columns.add(
      new Column('application', formatMessage(messages.application), {
        sorting: true,
        render: ({ application: { appName } }) => appName,
      }),
    )
    columns.add(
      new Column('licensee', formatMessage(messages.licensees), {
        render: ({ application: { licenseeName } }) => licenseeName,
      }),
    )
    columns.add(
      new ActiveColumn('embedLink', formatMessage(messages.embedLink), {
        render: ({ embedLink }) => !!embedLink,
      }),
    )
    columns.add(
      new ActiveColumn('parameters', formatMessage(messages.parameters), {
        render: ({ parameters }) => isEmpty(parameters),
      }),
    )
    columns.add(
      new Column('orderNumber', formatMessage(messages.orderNumber), {
        sorting: true,
        render: ({ orderNumber }) => orderNumber,
      }),
    )
    columns.add(
      new DateColumn('dateUpdated', formatMessage(messages.dateUpdated), {
        sorting: true,
      }),
    )

    return columns
  }

  getActions() {
    const {
      intl: { formatMessage },
      history,
    } = this.props
    const actions = new ActionCollection()

    actions.add(
      new Action(
        'edit',
        formatMessage(messages.editSisenseDashboard),
        ({ id }) => {
          history.push(UrlHelper.create(ROUTE.SISENSE_EDIT, { id }))
        },
      ),
    )
    actions.add(
      new Action(
        'delete',
        formatMessage(messages.deleteSisenseDashboard),
        ({ id }) => {
          this.onOpenConfirmDialog({
            entityId: id,
            psfs: this.psfs,
          })
        },
      ),
    )

    return actions
  }

  getConfirmDialogProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.deleteSisenseDashboard),
      message: formatMessage(messages.deleteSisenseDashboardMessage),
    }
  }
}

export default connect(
  state => ({
    tableData: state.getIn(['sisense', 'tableData']),
    licenseeId: state.getIn(['profile', 'licenseeId']),
  }),
  {
    sisenseFetchTableData,
    sisenseClearStateList,
    sisenseDelete,
  },
)(injectIntl(SisenseDashboardList))
